import React, {useState, useEffect} from "react"
import Layout from "../components/layout.js"
import style from "./exhibitions.module.css"
import SectionHeader from "../components/section-header-text.js"
import NestedDiv from "../components/nested-div.js"
import { graphql } from "gatsby"
import PastGallery from "../components/past-gallery.js"


export default function Exhibitions({data}) {

const [time, setTime] = useState('now')
const [pastButton, setPast] = useState('')
const [nowButton, setNow] = useState(' ' + style.currentButton)
const [futureButton, setFuture] = useState('')

  return (
        <Layout>
            <div>
              <SectionHeader text = "EXHIBITIONS"/>
              <div className = {style.timeBar}>
                  <button onClick = {()=>{setTime('past'); setPast(' ' + style.currentButton); setNow(''); setFuture('');}} className = {style.timeButton + pastButton}>Past</button>
                  <button onClick = {()=>{setTime('now'); setPast(''); setNow(' ' + style.currentButton); setFuture('');}} className = {style.timeButton + nowButton}>Now</button>
                  <button onClick = {()=>{setTime('future'); setPast(''); setNow(''); setFuture(' ' + style.currentButton);}} className = {style.timeButton + futureButton}>Future</button>
              </div>
              <NestedDiv className = {style.image} selector = 'past' current = {time}>
                <PastGallery data = {data}/>
                <p>
              2017/12/2−12/10 個展  「アイム シーイング ベイベ」 丸橋 光生<br/>
  2017/11/14−11/23 個展  「衝動とその周辺にあるもの」 飯川 雄大<br/>
  2017/5/7−5/14 グループ展  「リバーズエッジ」 芦田奈津実 黒田大祐<br/>
  2017/4/15−4/23 個展  「WWYWOADFTY」 German Stegmaier<br/>
  2017/3/4−3/12 個展  「追体験の絵画／Vicarious painting」    加茂 昂<br/>
  2017/2/22−2/26 グループ展  「新世界へ」     板井三那子、井地野乃花、梅田綾香、クサムラマッドラット、米野まふみ、畠中彩、古川千夏、松本千里、Le Mette' Adeline<br/>
  2017/2/12−2/19 グループ展  「虹／Rainbow」     青原恒沙子 高瑞雪 七搦綾乃<br/>
  2017/1/28−2/5 グループ展  「家／House」  岸かおる 花岡美優 山崎稚子<br/>
  2017/1/16−1/22 グループ展  「Net-to-Net」     キム・ギョンハ、ユン・ピルナム<br/>
  2016/12/17−12/25 個展  「雲の下で」    潘逸舟<br/>
  2016/11/12−11/20 個展  「ないぞうするこころ」    山田哲平<br/>
  2016/10/15−10/23 個展  「ねずみまち」    尾本恵美<br/>
  2016/7/16−7/24 個展  「branch」    粕谷優<br/>
  2016/6/18−6/26 個展  「無形」    呉 青峰（ウー・チンフン）<br/>
  2016/2/21−2/28 個展  「An Echo」    김지곤（キム・ジゴン）<br/>
  2016/1/23−2/6 グループ展  「VIA ART」    ジョン・マンヨン、キム・ボギョン、呉青峰、オマル・ロサレス、七搦綾乃<br/>
  2015/12/24−27 グループ展  「untitle-6」 七搦綾乃、黒田大祐、丸橋光生、入江早耶、鹿田義彦、中森詔子、チームやめよう、船田奇岑、キム・ボギョン、桒原寿行、チャールズ・ウォーゼン、伊東敏光、ジョン・マンヨン、オマル・ロサレス、岸かおる、花岡美優、久保寛子、加藤果琳、河田百代、江森郁美<br/>
  2015/10/24−31 個展  「Memory Glomeration」 김보경(キム・ボギョン)<br/>
  2015/8/29−9/6 個展  「EYE  HIROSHIMA」     桒原寿行 <br/>
  2015/7/18−23 グループ展  「theorein -静かに何かを観続ける」    青原恒沙子、加藤果琳、前田春日美 <br/>            
  2015/7/13、14 グループ展  「Team Yameyou」<br/>
  2015/4/25－5/6 個展 「Reflected sound」        Manyoung jung/ジョン・マンヨン<br/>
  2015/4/11－4/19 グループ展 「A」      諫山元貴、Sebastian Scherl、花岡美優、河田百代<br/>
  2015/3/21－3/29 グループ展 「Obake Hotel」    Ｃｕｒｔｉｓ Ｊａｃｋｓｏｎ Davis、Daisuke kuroda、Gregory Ruppe、Jeff Gibbons、Jesse Morgan、Karin Lehmann、Kris Pierce、Mitsuo Maruhashi、Nino Baumgartner、Omar Rosales、Pierre Burger<br/>
  2015/2/21－3/1 グループ展 「極薄」 鹿田義彦、遠藤優斗、高瑞雪<br/>
2015/2/14－3/15 グループ展 THE ART FAIR +PLUS-ULTRA 2014 広島芸術センター出品作家による報告展「今はもう存在しない星の光を“美しい”と思う理由」
七搦綾乃、米倉大五郎、粕谷優、有瀬龍介、芦田奈津美、黒田大祐(アートギャラリーミヤウチにて)<br/>
2015/1/18－1/24 グループ展 「 漂動するかたち」 板井美那子、植田千遥、加藤果琳、加藤望、田中廉士、花岡美優、平野あゆみ、三好帆南、森永悠太、湯川玲奈<br/>
2015/1/9、10 グループ展 新春小作品展「空間、詩、手、を眼で問う。2015」<br/>
2014/12/26－12/29 グループ展 アーカンソー土窯プロジェクト企画展「 Kua’at」 平川忠、クリス・パウェル、赤井夕希子、久保寛子<br/>
2014/12/13－12/21 グループ展 「毎日とハピネス -daily & happiness- 」丸橋光生、山崎悠斗<br/>
2014/11/30－12/7 グループ展 「広島芸術学会展示企画 横川創荘・広島芸術センター・蟹屋 Fine Arts 合同展」 黒田大祐、加藤果琳、七搦綾乃<br/>
2014/10/31－11/3 アートフェア出展 「THE ART FAIR +PLUS-ULTRA 2014 ULTRA category 2nd Term」(スパイラルガーデン  東京都港区南青山5-6-23)<br/>
2014/7/25－7/31 リレー展  「l’ universo nella noce クルミの中の宇宙」第３週目「Tempo-Vuoto 時間の空白」 リディア・アチェト<br/>
2014/7/18－7/24 リレー展  「l’ universo nella noce クルミの中の宇宙」第2 週目「Prismatic」 藤田はるか<br/>
2014/ 7/11－7/17  リレー展  「l’ universo nella noce クルミの中の宇宙」 第1 週目「Nulla è accaduto in passato 」過去には何も起こらなかった 岡崎歩<br/>
2014/ 6/29 イベント 「若者勉強会」 西村七海、加藤果琳、中村紗千、遠藤優斗 他<br/>
2014/ 5/23－6/1  グループ展 「絶滅考2」 土屋祐二、中村紗千、園田昂史<br/>
2014/5/4－5/7     個展  「ぜんぶやめよう」 チームやめよう/Team Yameyou<br/>
2014/3/14－3/23 グループ展 「絶滅考」    粕谷優/Yu kasuya、工藤理瑛/Rie Kudo、高瑞雪/Miyuki Kou<br/>
2014/3/1－3/9       グループ展「もやし展」 小松原裕輔、西村七海、三好帆南、加藤果琳、中村紗千、清岡舞、梁谷侑未、遠藤優斗、吉本芽<br/>
2014/1/18日－1/25 個展『Ｎ』  諫山元貴/Genki Isayama<br/>
 2013/12/14-12/22  個展「ここに柱がある、確かに」 増田純/Jun Masuda<br/>
2013/1１/24-12/１ 個展 『つみくさ』 是恒さくら/Sakura Koretsune  <br/>
2013/10/11-10/20 個展 「現代農耕文化の仮面展」 久保寛子/Hiroko Kubo<br/>
2013/9/15-9/23 個展 「ケンナイ」  川田淳/Jun Kawada<br/>
2013年7/27－8/6   「殿敷侃 展 ―広島スクリーン印刷との関わりから―」       殿敷侃、斉藤伸三（企画：中村有丞）<br/>
2013/7/12-7/21 個展 「spare-part」 岸かおる/Kaoru Kisi<br/>
2013/6/15-6/23   個展「かたいモノほど壊れやすい」   友定睦/ Mutsumi Tomosada<br/>
2013/6/1日‐6/9  個展 「Re Exposure」 鹿田義彦/Yoshihiko Shikada<br/>
2013/5/1-5/7      有瀬龍介の壺の絵と銭本眞理による壺の展覧会「壺中之天」   有瀬龍介/Ryusuke Aruse:銭本眞理/Mari Zenimoto<br/>
2013/4/20-4/29    メキシコ人アーティストによるグループ展『GAMEX』  OMAR CASILLAS オマル・カシヤス、 ANNABEL CASTRO アナベル・カストロ, DON CHARLES ドン・チャレス、CYNTHIA CHONG  シンティアグ・チョング、JAVIER GUTIERREZ ハビエル・グティエレス、RIGEL HERRERAリヘル・エレラ、 TRINI IBARRA  トリニ・イバラ、MARCO ANTONIO LARA  マルコ・アントニオ・ララ、YAZMIN MAYA   ヤスミン・マヤ、ERNESTO MORALESエルネスト・モラレス、EDUARDO ORTIZ  エドアルド・オルティス、CARLOS PEREZ BUCIOカルロス・ペレス・ブシオ、LAURA PIREZ ラウラ・ピレス、MARCO RIOS マルコ・リオス、JOSE LUIS ROJAS  ホセルイス・ロハス, ALINA SANCHEZ アリナ・サンチェス,RODRIGO ZAVALA ロディゴ・サバラ,Erik Bachtold Meyer エリック・バヒトルド・メイヤー<br/>
2012/12/21-12/22  としわすれ くるとしの はなしをしよう <br/>
2012/12/8-12/16 『「FORTRESS」とロールシャッハ部』  野村 拓也/ TakuyaNomura<br/>
2012/11/23-25,12/1-2    「妙」 －丸橋直継 仏像彫刻作品展－       丸橋直継/NaotsuguMaruhashi<br/>
2012/7/25－7/29 「枝のわかれ 先の先 七搦綾乃/Ayano Nanakarage :黒田大祐/Daisuke Kuroda：丸橋光生/Mitsuo Maruhashi：園田昂史/Takashi/Sonoda<br/>
2012/7/14-22             個展 『 十茨塚 』 三坂優/Yu Misaka<br/>
2012/7/1-7         個展 『In the vague world』  市田みなみ/Minami Ichida<br/>
2012/6/2-9        小作品展 「There you are －そこにいる－」  松尾真由美/Mayumi Matuo <br/>                      
2012/5/20-27    個展「虚構の都市」山本辰典/Tatunori Yamamoto<br/>
2012/2/25-3/4   個展「Children see,children do」 七搦綾乃/Ayano Nanakarage <br/>                
2012/1/21-29     Irie Saya Solo Exhibition 未確認動物展    入江早耶 /Saya Irie <br/>                            
2012/1/7-15       「山/影 mountain/Shadow」  土屋祐二/Yuji Tuchiya<br/>
2011/12/18-25   個展    チャールズ・ウォーゼン/Charles Worthen<br/>
2011/12/9-12     「闇と光」  楠直明/Naoaki Kusunoki
2011/18-27         「色」   オマル・ロサレス/Omar Rosales<br/>     
2011/11/2-6       新作展「プラスティック調教」 丸橋光生/Mitsuo Maruhashi<br/>                     
2011/10/22-30   個展「Ｄｒｅam Shit」   田中圭子/Keiko Tanaka<br/>                    
2011/10/8-16     Ｐarallel screen      中村有丞/Yusuke Nakamura<br/>                  
2011/9/10-11     広島糸Zakka市 Part2<br/>
2011/9/1-5        作品展      江森郁美/Ikumi Emori<br/>      
2011/6/17-23     個展「Spectrum」   水口鉄人/Tetuto Mizuguchi<br/>
2011/6/5-12       個展 「HEAVEN ? 」 増田純/Jun Masuda<br/>
2011/5/1-8         group※展     米田章/ Akira Yoneda:友定睦/Mutsumi Tomosada<br/>
2011/3/3-9         女子会<br/>
2011/2 「くもをつかむようなはなし」田中圭子/Keiko Tanaka :七搦綾乃/Ayano Nanakarage :黒田大祐/Daisuke Kuroda<br/>                   
2011/2/25-27      TEAM YAMEYOU.1    チームやめよう/Team Yameyo<br/>
2010/12/13-19    近作展    諫山元貴/Genki Isayama:石黒健一/Kenichi Ishiguro:入江早耶/Saya Irie:鹿田義彦/yoshihiko Shikada<br/>         
2010/11/1-7  それはまるでカビのようでもあり 白い雲のようでもある    楠直明/Naoaki Kusunoki :七搦綾乃/Ayano Nanakarage :黒田大祐/Daisuke Kuroda<br/>



              </p>
              </NestedDiv>
              <NestedDiv className = {style.image} selector = 'now' current = {time}>
              {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 6].exhibitionsPage ?
                <img src={data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 6].exhibitionsPage} alt = "Current Exhibition"/> :
                <img src="https://lh3.googleusercontent.com/pw/ACtC-3cko_NuDOFUO0n3LvYGmke3OnYIE8Ucfz6k_3xKUdvENF5aVd4lQwUMvue-wadO9UkCRd65r1uhw2RmvXy_5qMd3iffye4Xxz6ibig4ULpLMlM6KQBLIMRKR-i1N8zbBJBNQn_bYcjJkqPMvq72ipHM=w1390-h943-no?authuser=0"
                alt = "Coming Soon"/>
              }
                <div className = {style.text}>
                {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 5].exhibitionsPage ?
                  <p style = {{fontWeight: "bold"}}>{data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 5].exhibitionsPage}</p> :
                  <p style = {{fontWeight: "bold"}}>Coming Soon</p> 
                }
                {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 4].exhibitionsPage ?
                  <p>
                    {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 4].exhibitionsPage}
                  </p> : 
                  <p>
                  </p> 
                }
                </div> 
              </NestedDiv>
              <NestedDiv className = {style.image} selector = 'future' current = {time}>
              {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 3].exhibitionsPage ?
                <img src={data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 3].exhibitionsPage} alt = "Next Exhibition"/> :
                <img src="https://lh3.googleusercontent.com/pw/ACtC-3cko_NuDOFUO0n3LvYGmke3OnYIE8Ucfz6k_3xKUdvENF5aVd4lQwUMvue-wadO9UkCRd65r1uhw2RmvXy_5qMd3iffye4Xxz6ibig4ULpLMlM6KQBLIMRKR-i1N8zbBJBNQn_bYcjJkqPMvq72ipHM=w1390-h943-no?authuser=0"
                alt = "Coming Soon"/>
              }
                <div className = {style.text}>
                {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 2].exhibitionsPage ?
                  <p style = {{fontWeight: "bold"}}>{data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 2].exhibitionsPage}</p> :
                  <p style = {{fontWeight: "bold"}}>Coming Soon</p> 
                }
                {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 1].exhibitionsPage ?
                  <p>
                    {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 1].exhibitionsPage}
                  </p> : 
                  <p>
                  </p> 
                }
                </div> 
              </NestedDiv>
            </div>
        </Layout>
  )
}

const past_text = [
  {text: '2017/12/2−12/10 個展  「アイム シーイング ベイベ」 丸橋 光生'},
  {text: "2017/11/14−11/23 個展  「衝動とその周辺にあるもの」 飯川 雄大"},
  {text: "2017/5/7−5/14 グループ展  「リバーズエッジ」 芦田奈津実 黒田大祐"},
  {text: "2017/4/15−4/23 個展  「WWYWOADFTY」 German Stegmaier"},
  {text: "2017/3/4−3/12 個展  「追体験の絵画／Vicarious painting」    加茂 昂"},
  {text: "2017/2/22−2/26 グループ展  「新世界へ」     板井三那子、井地野乃花、梅田綾香、クサムラマッドラット、米野まふみ、畠中彩、古川千夏、松本千里、Le Mette' Adeline"},
  {text: "2017/2/12−2/19 グループ展  「虹／Rainbow」     青原恒沙子 高瑞雪 七搦綾乃"},
  {text: "2017/1/28−2/5 グループ展  「家／House」  岸かおる 花岡美優 山崎稚子"},
  {text: "2017/1/16−1/22 グループ展  「Net-to-Net」     キム・ギョンハ、ユン・ピルナム"},
  {text: "2016/12/17−12/25 個展  「雲の下で」    潘逸舟"},
  {text: "2016/11/12−11/20 個展  「ないぞうするこころ」    山田哲平"},
  {text: "2016/10/15−10/23 個展  「ねずみまち」    尾本恵美"},
  {text: "2016/7/16−7/24 個展  「branch」    粕谷優"},
  {text: "2016/6/18−6/26 個展  「無形」    呉 青峰（ウー・チンフン）"},
  {text: "2016/2/21−2/28 個展  「An Echo」    김지곤（キム・ジゴン）"},
  {text: "2016/1/23−2/6 グループ展  「VIA ART」    ジョン・マンヨン、キム・ボギョン、呉青峰、オマル・ロサレス、七搦綾乃"},
  {text: "2015/12/24−27 グループ展  「untitle-6」 七搦綾乃、黒田大祐、丸橋光生、入江早耶、鹿田義彦、中森詔子、チームやめよう、船田奇岑、キム・ボギョン、桒原寿行、チャールズ・ウォーゼン、伊東敏光、ジョン・マンヨン、オマル・ロサレス、岸かおる、花岡美優、久保寛子、加藤果琳、河田百代、江森郁美"},
  {text: "2015/10/24−31 個展  「Memory Glomeration」 김보경(キム・ボギョン)"},
  {text: "2015/8/29−9/6 個展  「EYE  HIROSHIMA」     桒原寿行 "},
  {text: "2015/7/18−23 グループ展  「theorein -静かに何かを観続ける」    青原恒沙子、加藤果琳、前田春日美 "},            
  {text: "2015/7/13、14 グループ展  「Team Yameyou」"},
  {text: "2015/4/25－5/6 個展 「Reflected sound」        Manyoung jung/ジョン・マンヨン"},
  {text: "2015/4/11－4/19 グループ展 「A」      諫山元貴、Sebastian Scherl、花岡美優、河田百代"},
  {text: "2015/3/21－3/29 グループ展 「Obake Hotel」    Ｃｕｒｔｉｓ Ｊａｃｋｓｏｎ Davis、Daisuke kuroda、Gregory Ruppe、Jeff Gibbons、Jesse Morgan、Karin Lehmann、Kris Pierce、"},]


export const query = graphql`
query {
  googleSheet {
    Sheet1 {
      mainImage
      text
      dm
      threeSixty
      exhibition
      exhibitionsPage
    }
  }
}`